import { titleCase } from 'utils/helperFunctions';

/** Prefer catalog label from the interaction payload; fall back to title-cased code. */
export function formatDisconnectionReason(code?: string | null, label?: string | null): string {
  if (label) return label;
  if (code) return titleCase(code);
  return '';
}
